/**
 * Hook to fetch current active catalogue information
 */

import { useState, useEffect } from 'react';

interface CatalogueInfo {
  name: string;
  weekNumber: number;
  year: number;
  validFrom: string;
  validUntil: string;
  promotionsCount: number;
}

export function useCatalogueInfo() {
  const [catalogueInfo, setCatalogueInfo] = useState<CatalogueInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCatalogueInfo();
  }, []);

  const fetchCatalogueInfo = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/catalogues/current`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch catalogue info');
      }

      const data = await response.json();
      
      if (data.success && data.catalogue) {
        const catalogue = data.catalogue;
        setCatalogueInfo({
          name: `Catalogue Netto - Semaine ${catalogue.weekNumber}`,
          weekNumber: catalogue.weekNumber,
          year: catalogue.year,
          validFrom: catalogue.startDate,
          validUntil: catalogue.endDate,
          promotionsCount: catalogue.promotions?.length || 0
        });
      }
    } catch (err: any) {
      console.error('Error fetching catalogue info:', err);
      setError(err.message);
      // Fallback to default
      setCatalogueInfo({
        name: 'Catalogue Netto',
        weekNumber: 51,
        year: 2025,
        validFrom: '2025-12-15',
        validUntil: '2025-12-21',
        promotionsCount: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    fetchCatalogueInfo();
  };

  return {
    catalogueInfo,
    loading,
    error,
    refresh
  };
}
